<template>
  <div>
    <p>Este é um texto para teste</p>
  </div>
</template>

<script>
export default {
    nome: 'TesteComponente'
}
</script>

<style>

</style>